// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assests/fonts/Agustina.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assests/fonts/Montserrat-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assests/fonts/GoogleSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assests/fonts/GoogleSans-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assests/fonts/GoogleSans-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assests/fonts/GoogleSans-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assests/fonts/GoogleSans-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assests/fonts/GoogleSans-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Agustina Regular";
  font-style: normal;
  font-weight: normal;
  src: local("Agustina Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
  font-family: "Montserrat";
  src: local("Montserrat"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
  font-family: "Google Sans Bold";
  src: local("Google Sans Bold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}

@font-face {
  font-family: "Google Sans Bold Italic";
  src: local("Google Sans Bold Italic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

@font-face {
  font-family: "Google Sans Italic";
  src: local("Google Sans Italic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff");
}

@font-face {
  font-family: "Google Sans Medium";
  src: local("Google Sans Medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

@font-face {
  font-family: "Google Sans Medium Italic";
  src: local("Google Sans Medium Italic"),
    url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff");
}

@font-face {
  font-family: "Google Sans Regular";
  src: local("Google Sans Regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

html,
body {
  scroll-behavior: smooth;
}

body {
  margin: 0;
  font-family: "Be Vietnam Pro", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  width: 100%;
}

::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-track {
  background: #292a2d;
}

::-webkit-scrollbar-thumb {
  background: #e3405f;
  border-radius: 5px;
}

::-webkit-scrollbar-thumb:hover {
  background: #e3405f;
}

/* Media Query */
@media (max-width: 1380px) {

  html,
  body {
    font-size: 16px;
    line-height: normal;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB;0DACqD;AACvD;;AAEA;EACE,yBAAyB;EACzB;0DAC8D;AAChE;;AAEA;EACE,+BAA+B;EAC/B;0DAC2D;AAC7D;;AAEA;EACE,sCAAsC;EACtC;0DACiE;AACnE;;AAEA;EACE,iCAAiC;EACjC;0DAC6D;AAC/D;;AAEA;EACE,iCAAiC;EACjC;0DAC6D;AAC/D;;AAEA;EACE,wCAAwC;EACxC;0DACmE;AACrE;;AAEA;EACE,kCAAkC;EAClC;0DAC8D;AAChE;;AAEA;EACE;aACW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,yCAAyC;EACzC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;;EAEE;;IAEE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":["@font-face {\n  font-family: \"Agustina Regular\";\n  font-style: normal;\n  font-weight: normal;\n  src: local(\"Agustina Regular\"),\n    url(\"./assests/fonts/Agustina.woff\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Montserrat\";\n  src: local(\"Montserrat\"),\n    url(\"./assests/fonts/Montserrat-Regular.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Bold\";\n  src: local(\"Google Sans Bold\"),\n    url(\"./assests/fonts/GoogleSans-Bold.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Bold Italic\";\n  src: local(\"Google Sans Bold Italic\"),\n    url(\"./assests/fonts/GoogleSans-BoldItalic.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Italic\";\n  src: local(\"Google Sans Italic\"),\n    url(\"./assests/fonts/GoogleSans-Italic.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Medium\";\n  src: local(\"Google Sans Medium\"),\n    url(\"./assests/fonts/GoogleSans-Medium.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Medium Italic\";\n  src: local(\"Google Sans Medium Italic\"),\n    url(\"./assests/fonts/GoogleSans-MediumItalic.ttf\") format(\"woff\");\n}\n\n@font-face {\n  font-family: \"Google Sans Regular\";\n  src: local(\"Google Sans Regular\"),\n    url(\"./assests/fonts/GoogleSans-Regular.ttf\") format(\"woff\");\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\nhtml,\nbody {\n  scroll-behavior: smooth;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Be Vietnam Pro\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  width: 100%;\n}\n\n::-webkit-scrollbar {\n  width: 10px;\n  height: 10px;\n}\n\n::-webkit-scrollbar-track {\n  background: #292a2d;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #e3405f;\n  border-radius: 5px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #e3405f;\n}\n\n/* Media Query */\n@media (max-width: 1380px) {\n\n  html,\n  body {\n    font-size: 16px;\n    line-height: normal;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
